export default __webpack_public_path__ + "static/media/edit_pen.2d14fef4.svg";